module.exports = __webpack_public_path__ + "img/dashboard (2).978c5d21.svg";